// extracted by mini-css-extract-plugin
export default {"addWrapper":"add-value-dialog_addWrapper__z5OjE"};